import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../../../../../../Translations';

export interface Props {
  submit: () => void;
  back: () => void;
}

const Submit: React.FC<Props> = ({ submit, back }) => (
  <div className="flex mt-16">
    <div
      className={clsx(
        'cursor-pointer rounded-md bg-white text-teal-600 border-teal-600 px-3 py-2 text-sm',
        ' w-24 text-center mt-4 border mr-4',
      )}
      onClick={back}
    >
      <T kind="Back" />
    </div>
    <div
      className={clsx(
        'cursor-pointer rounded-md bg-teal-600 text-white px-3 py-2 text-sm w-24 text-center mt-4',
      )}
      onClick={submit}
    >
      <T kind="Submit" />
    </div>
  </div>
);

export default observer(Submit);
